import React, { useEffect, useState } from 'react';
import { fetchPickPackList } from 'services';
import { showError, sortArray } from 'utils';
import _ from 'lodash';

const PickPackListDropdown = props => {
  const [loading, setLoading] = useState<boolean>(true);
  const [pickPackList, setPickPackList] = useState<Record<string, any>[]>([]);
  const [listForDropDown, setListForDropDown] = useState<Record<string, any>[]>([]);
  const { disabled, selectedList, setListDetails, setSelectedList } = props;

  const fetchPickPackLists = async () => {
    try {
      const response = await fetchPickPackList({
        page: 0,
        limit: 25,
      });
      const pickPackLists = response.items.map(row => {
        return {
          id: row.objectId,
          name: row.name,
        };
      });
      setPickPackList(response.items);
      setListForDropDown(pickPackLists);
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPickPackLists();
  }, []);

  const handleSelect = (listId: string) => {
    setSelectedList(listId, _.find(pickPackList, ['objectId', listId]));
    setListDetails && setListDetails(_.find(pickPackList, ['objectId', listId]));
  };

  const getListOptions = () => listForDropDown.map((list, i) => (
    <option key={i} value={list.id}>{list.name}</option>),
  );

  return (
    <select
      value={selectedList}
      disabled={loading || disabled}
      className='form-control'
      onChange={e => handleSelect(e.target.value)}
    >
      <option value='none' hidden={!!selectedList}>Select a Pick Pack List</option>
      {pickPackList.length && getListOptions()}
    </select>
  );
};

export default PickPackListDropdown;